"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.initialState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actions = require("./actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  guid: '',
  userToken: '',
  institution: null,
  loginPreload: null,
  accounts: null,
  selectedAccounts: null,
  incomeAccountData: null,
  enableNoneAreMyIncome: true,
  enableTotalIncomeNotShown: false
};
exports.initialState = initialState;

var reducer = function reducer(state, action) {
  switch (action.type) {
    case _actions.Actions.INIT_CONFIG:
      return _objectSpread(_objectSpread({}, state), action.data);

    case _actions.Actions.SET_INSTITUTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        institution: action.data
      });

    case _actions.Actions.SET_LOGIN_PRELOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        loginPreload: action.data
      });

    case _actions.Actions.SET_ACCOUNTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        accounts: action.data
      });

    case _actions.Actions.SET_SELECTED_ACCOUNTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedAccounts: action.data
      });

    case _actions.Actions.SET_INCOME_ACCOUNT_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        incomeAccountData: action.data
      });

    case _actions.Actions.RESET:
      return initialState;

    default:
      throw new Error();
  }
};

exports.reducer = reducer;